import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { optionsWithDefaults } from "../_helpers/options-with-defaults";
import { Options } from "../_types";

export const MODEL_FAMILY_BY_UUID_RESOURCE = "model-family" as const;
export const MODEL_FAMILY_BY_UUID_API_PATH = `/v1/${MODEL_FAMILY_BY_UUID_RESOURCE}/{uuid}` as const;

export type ModelFamilyByUuidParameters = paths[typeof MODEL_FAMILY_BY_UUID_API_PATH]["get"]["parameters"]["query"];
export type ModelFamilyByUuidResponse =
  paths[typeof MODEL_FAMILY_BY_UUID_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useModelFamilyByUuidQuery(uuid: string, options?: Options<ModelFamilyByUuidParameters, never>) {
  const optionsWithDefaultsResolved = optionsWithDefaults<Options<ModelFamilyByUuidParameters, never>>(options);

  const requestParameters: ModelFamilyByUuidParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
    extend: optionsWithDefaultsResolved.parameters?.extend || [],
  };

  return useQuery({
    enabled: !!uuid,
    queryKey: [MODEL_FAMILY_BY_UUID_RESOURCE, uuid, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<ModelFamilyByUuidResponse>(
        `/v1/${MODEL_FAMILY_BY_UUID_RESOURCE}/${uuid}`,
        {
          params: requestParameters,
        },
      );

      return response.data;
    },
  });
}
